<template>
	<div class="CoinsReport">
		<div class="query">
			<el-select v-model="bookTitle" 
			placeholder="Please select" 
			style="width:30%;padding-right: 40px;" 
			@change="selectbook()" 
			@clear="setValueNull"
			clearable>
			    <el-option
			      v-for="item in booklist"
			      :label="item.worksName"
			      :value="item.worksName"
				  >
			    </el-option>
			  </el-select>
			  <el-date-picker
			      v-model="startDate"
				  type="date"
				  style="width:20%"
			      placeholder="Start Date"
				  @change="starttime()"
				  >
			  </el-date-picker>
			  <span></span>
			  <el-date-picker
			      v-model="endDate"
				  type="date"
				  style="width:20%"
			      placeholder="End Date"
				  >
			  </el-date-picker>
			  <el-button class="seabut" @click="search()">Search</el-button>
		</div>
		<div>
			<el-table
			    :data="tableData"
			    stripe
			    style="width: 100%;padding-top: 10px;"
				>
			    <el-table-column prop="date" label="Date" width="180"></el-table-column>
			    <el-table-column prop="title" label="Title" width="120"></el-table-column>
			    <el-table-column prop="coins" label="Coins Received"></el-table-column>
				<el-table-column prop="chapters" label="Number of Purchases"></el-table-column>
				<el-table-column prop="app" label="App">  </el-table-column>
			  </el-table>
		</div>
	</div>
</template>

<script>
	import { 
	apiGetIncomeDailyDetail,
	apiGetAuthorWorksListone,
	} from '../common/api/workincome.js'
	export default{
		data() {
	      return {
	        bookTitle: '' ,//书名
			startDate:"", //开始时间
			endDate:"",//结束时间
			tableData: [],
			bookId:0,//书籍ID
	      }
	    },
		props:{
			booklist:Array
		},
		created(){
			//获取前一个月
			this.startDate = this.getlastMonth()
			const replaceStr = (str, index, char) => {
			 return str.substring(0, index) + char + str.substring(index + 8);
			}
			this.startDate = new Date(replaceStr(this.startDate.toString(),16,"00:00:00"))
			this.endDate = new Date(new Date().getTime() - 24*60*60*1000)
			this.endDate = new Date(replaceStr(this.endDate.toString(),16,"00:00:00"))
			this.getDetailList()
			// this.getbooklist()
		},
		methods:{
			getDetailList(){		
				//每日消耗书币传参
				const replaceStr = (str, index, char) => {
				 return str.substring(0, index) + char + str.substring(index + 4);
				}
				const strattime = new Date(replaceStr(Date().toString(),11,2020))
				let coinsdata={
					data:{
						AuthorId: this.$store.state.userInfo == undefined ? 0 : this.$store.state.userInfo.id,
						beginTime:this.startDate==null?strattime:new Date(new Date(this.startDate).getTime() + 24*60*60*1000),
						endTime: this.endDate==null?new Date():new Date(new Date(this.endDate).getTime() + 24*60*60*1000),
						bookId: this.bookId
					}
				}
				
				apiGetIncomeDailyDetail(coinsdata).then(res=>{
					if(res.code == 0){
						this.tableData = res.data
						for(let i in this.tableData){
							this.tableData[i].date = this.formatDate(this.tableData[i].date)
							//替换指定位置的字符
							const replaceStr = (str, index, char) => {
							 return str.substring(0, index) + char + str.substring(index + 2);
							}
							let aa = this.datescreen(this.tableData[i].date.slice(0,2))
							this.tableData[i].coins = this.adjust(this.tableData[i].coins,2)
							this.tableData[i].date = replaceStr(this.tableData[i].date.toString(),0,aa)
							if(this.bookTitle){
								this.tableData[i].title = this.bookTitle
							}
						}
					}
				})
			},
			
			//选择书籍
			selectbook(){
				for(let i in this.booklist){
					if(this.bookTitle == this.booklist[i].worksName){
						this.bookId = this.booklist[i].id
					} 
				}
			},
			setValueNull(){
				this.bookId = 0
			},
			//选择开始时间
			starttime(){
			},
			//查询方法
			search(){
				this.getDetailList()
			},
			
			// 获取当前日期的上一个月
			getlastMonth() {
			    let now = new Date();
			    // 当前月的日期
			    let nowDate = now.getDate();
			    let lastMonth = new Date(now.getTime());
			    // 设置上一个月（这里不需要减1）
			    lastMonth.setMonth(lastMonth.getMonth());
			    // 设置为0，默认为当前月的最后一天
			    lastMonth.setDate(0);
			    // 上一个月的天数
			    let daysOflastMonth = lastMonth.getDate();
			    // 设置上一个月的日期，如果当前月的日期大于上个月的总天数，则为最后一天 
			    lastMonth.setDate(nowDate > daysOflastMonth ? daysOflastMonth : nowDate);
			    return lastMonth;
			},
			
			//修改时间样式
			formatDate(Time) { //获得UTC的时间
				const moment = require('moment-timezone');
				if (Time == null) {
					return null
				}
				var timezone = "Asia/Shanghai";
				const clean = moment(Time).format('MM-DD-YYYY'); // 清除 timezone 信息
				const Shanghailocal = moment.tz(clean, timezone);
				return Shanghailocal.tz('UTC').format('MM-DD-YYYY')
			},
			datescreen(name){
				switch(name){
					case '01':
						return 'Jan'
						break;
					case '02':
						return 'Feb'
						break;
					case '03':
						return 'Mar'
						break;
					case '04':
						return 'Apr'
						break;
					case '05':
						return 'May'
						break;
					case '06':
						return 'Jun'
						break;
					case '07':
						return 'Jul'
						break;
					case '08':
						return 'Aug'
						break;
					case '09':
						return 'Sep'
						break;
					case '10':
						return 'Oct'
						break;
					case '11':
						return 'Nov'
						break;
					case '12':
						return 'Dec'
						break;
				}
			
			},
			//四舍五入
			adjust(numberRound,roundDigit){
			  if (numberRound>=0){
			  var tempNumber = parseInt((numberRound * Math.pow(10,roundDigit)+0.5))/Math.pow(10,roundDigit);
			  tempNumber += ''
			  if (!/\./.test(tempNumber)) {
			      tempNumber += '.00'
			  }
			  var arrayNum = tempNumber.split('.')
			  if (arrayNum[1].length < 2) {
			     tempNumber += '0'
			  }
			  return tempNumber;
			  } else{
			  var numberRound1=-numberRound;
			  var tempNumber = parseInt((numberRound1 * Math.pow(10,roundDigit)+0.5))/Math.pow(10,roundDigit);
			  return -tempNumber;
			
			  }
			}
			

		}
	}
</script>

<style lang="scss" scoped="scoped">
	.CoinsReport{
		/deep/.el-table__cell.is-leaf{
			background-color: antiquewhite;
		}
		.query{
			margin: 10px 10px 10px 20px;
			span{
				width: 10px;
				border: 1px solid #ccc;
				margin: 10px 10px 10px 10px;
				display: inline-block;
				position: relative;
				top: 6px;
			}
			.seabut{
				border: 0px solid red;
				border-radius: 5px;
				background: antiquewhite;
				color: coral;
				height: 40px;
				margin-left: 30px;
			}

		}
	}
</style>